import { render, staticRenderFns } from "./PortalIcon.vue?vue&type=template&id=3157ae57&scoped=true"
import script from "./PortalIcon.vue?vue&type=script&lang=js"
export * from "./PortalIcon.vue?vue&type=script&lang=js"
import style0 from "./PortalIcon.vue?vue&type=style&index=0&id=3157ae57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3157ae57",
  null
  
)

export default component.exports